import { useMemo } from 'react';
import { Option, useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const CANCELLED = 'CANCELLED';

interface ClaimStatus {
  id: string;
  name: string;
  description: string;
}

export const getClaimStatuses = () => api.get(API_URL.ENUMS_CLAIM_STATUS);

export const QUERY_KEY = 'getClaimStatuses';
const useGetClaimStatusesQuery = () => {
  const { data, isLoading } = useQuery([QUERY_KEY, getClaimStatuses], getClaimStatuses);

  const claimStatuses = useMemo(
    () =>
      data?.data.map(
        (item): ClaimStatus => ({
          id: toString(item.id),
          name: item.name || '',
          description: item.description || '',
        })
      ) || [],
    [data]
  );

  const statusesWithoutCanceled = useMemo(
    () => claimStatuses.filter((item) => item.name !== CANCELLED),
    [claimStatuses]
  );

  const options = useMemo<Option[]>(() => {
    const list = data?.data || [];
    return list.map((item) => ({
      key: `${item.name}`,
      value: item.description,
      title: item.description,
    }));
  }, [data?.data]);

  return {
    isLoading,
    claimStatuses,
    options,
    statusesWithoutCanceled,
  };
};

export default useGetClaimStatusesQuery;
